<template>
  <div class="flex justify-center items-center flex-col min-h-screen">
    <LanguageSelector />
    <div class="w-full md:w-2/3 lg:w-1/2">
      <div
        style="max-width: 527px" class="mx-auto mb-8 px-4 md:px-8 pt-12 pb-16 md:bg-white md:shadow-default"
      >
        <!-- logo -->
        <div class="text-center mt-6 md:mt-3 mb-12">
          <img class="inline w-full h-auto" :src="whiteLabel.logoUrl" alt="logo" />
        </div>
        <form
          @submit.prevent="submitLogin"
          class="bg-white shadow md:shadow-none rounded px-5 py-8 md:p-0"
          novalidate
        >
          <input-module
            :label="$t('Email')"
            type="email"
            name="email"
            rules="required|email"
            class="mb-4"
            labelClass="mb-2 text-grey-dark-light"
            inputClass="h-12 pl-3 pr-10 text-sm text-grey-darkest"
            v-model="user.email"
          />
          <input-module
            :label="$t('Password')"
            type="password"
            name="password"
            rules="required|min:8"
            class="mb-4"
            inputClass="h-12 px-3 text-sm text-grey-darkest"
            labelClass="mb-2 text-grey-dark-light"
            v-model="user.password"
          />
          <div class="flex items-center justify-between mb-5 text-3xs md:text-xs">
            <checkbox-module :label="$t('Remember email')" labelClass="ml-2 md:ml-4" v-model="user.rememberMe" />
            <router-link class="italic" :to="{ ...baseRouteConfig, name: 'reset-password' }">{{
              $t('Forgot your password?')
            }}</router-link>
          </div>
          <!-- button -->
          <button-module class="w-full py-3">{{ $t('Login') }}</button-module>
        </form>
      </div>
      <!-- footer -->
      <div class="flex justify-center text-2xs mb-12">
        <img src="@/assets/chrome.png" style="width: 1rem" />&nbsp;
        <p v-html="$t('Optimized Browser')"></p>
      </div>
      <div class="text-center text-2xs">
        <img class="inline h-12 mb-2" src="@/assets/short-logo.png" alt="footer-logo" />
        <p v-html="$t('Powered By Raisr', { year: new Date().getFullYear() })"></p>
      </div>
    </div>
  </div>
</template>

<script>
import InputModule from '@/components/form/InputModule'
import CheckboxModule from '@/components/form/CheckboxModule'
import ButtonModule from '@/components/shared/ButtonModule'
import LanguageSelector from '@/components/shared/LanguageSelector'
import LoginMixin from '@/mixins/LoginMixin'
import { useForm } from 'vee-validate'

export default {
  name: 'LoginPage',
  components: {
    InputModule,
    CheckboxModule,
    ButtonModule,
    LanguageSelector
  },
  mixins: [LoginMixin],

  setup () {
    /* Has to live in the component's own setup() - Vue 3 ignores setup() in a
       mixin. Creates the context the InputModule fields register into. */
    const { validate } = useForm()

    return { validateForm: validate }
  },

  data () {
    return {
      user: {
        email: '',
        password: '',
        rememberMe: true
      },
      savedUrl: this.$route.params.savedUrl
    }
  },

  methods: {
    async submitLogin () {
      const { valid } = await this.validateForm()
      if (!valid) return

      this.loginCallBack()
    }
  }
}
</script>
